// The validation enum for csv file
enum CsvValidation {
  Valid = 0,
  Partial = 1,
  Invalid = 2,
  Unknown = 3,
}

export default CsvValidation;



// WEBPACK FOOTER //
// ./src/scripts/models/CsvValidation.ts